<template>
  <div class="looking_site">
    <van-nav-bar title="场地方入驻协议" left-arrow @click-left="goback()" />
    <div v-html="content"></div>
  </div>
</template>

<script>
import { Button } from "vant";
import { NavBar } from "vant";
import { Form, Field, CellGroup } from "vant";
import { RadioGroup, Radio } from "vant";
import { Icon } from "vant";
import { ActionSheet, Cascader, Popup, Image, Notify } from "vant";

export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [Image.name]: Image,
  },
  data() {
    return {
      submitData: {
        company: "",
        contactName: "",
        contactNumber: "",
        remark: "",
      },
      newvalue: null, //当前值
      oldvalue: null,
      content: ""
    };
  },


  created() {
    // 场地方管理-列表
    this.listBySiteSupplierId();
  },

  methods: {

    // 场地方管理-列表
    listBySiteSupplierId() {
      var that = this;
      that.$api
        .protocolManualAPI({ type: 2 })
        .then(function (res) {
          if (res.data.code === 200) {
            that.content = res.data.data.content
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    dyDeselect(index) {
      // 判断当前值和旧的值是否相等
      if (index === this.oldvalue) {
        this.newvalue = null;
        this.oldvalue = null;
      } else {
        this.oldvalue = index;
      }
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        //this.$router.go(-1);
        this.$router.push({ path: "/personal/index" });
      }
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
      this.showCascader = false;
    },

    // 选中类型
    onSelectType(item) {
      this.showType = false;
    },

    // 选中注册
    onSelectRegister(item) {
      this.showRegister = false;
    },

    //提交申请场地
    onSubmit() {
      var that = this;
      if (that.newvalue != null) {
        that.$api
          .distributorApplySaveAPI(that.submitData)
          .then(function (res) {
            if (res.data.code === 200) {
              //跳转提交帮我找场地表单成功界面
              that.$router.push({ path: "/home/submitLookingSite" });
            }
          })
          .catch(function (err) {
            console.log("error");
          });
      } else {
        Notify({ type: "warning", message: "请点击同意场地协议！" });
        return;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.looking_site {
  display: flex;
  flex-direction: column;

  .site_form {
    padding: 0px 10px;
    height: auto;

    .form_tag {
      display: flex;
      justify-content: space-between;
      padding: 0px 20px;
    }

    .van-cell {
      display: flex;
      align-items: flex-start;
    }

    .van-field {
      /deep/ textarea {
        height: 100px !important;
        background: #f4f3f8;
        padding: 5px;
      }
    }

    .form_feature {
      color: #646566;
      margin: 15px 10px;

      .fs28::after {
        position: absolute;
        left: 110px;
        color: #ee0a24;
        margin-top: 5px;
        font-size: 8px;
        content: "*";
      }

      .van-button {
        height: 35px;
        margin-top: 15px;
        margin-right: 15px;
      }
    }
  }

  .van-radio-group {
    margin: auto;
    margin-top: 40px;
    font-size: 13px;
    display: flex;
    justify-content: center;
  }

  .form_btn {
    margin: 40px 10px;

    .van-button {
      height: 44px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/personal/placeAgreement.vue